import { LocalStorageRepository } from "./_LocalStorageRepository";

const keyStorage = "@event-session";

// Sessão (caixa) retornada no login do evento, vinculada ao registro de sessão do equipamento
export interface IEventSession {
  registroSessaoPOSId: string;
  sessionId: string;
}

export const EventSessionStorage = () => {
  const localStorageRepository = LocalStorageRepository();

  const saveAsync = async (eventSession: IEventSession): Promise<void> => {
    await localStorageRepository.post(keyStorage, eventSession);
  };

  // Só devolve a sessão se ela ainda pertencer ao registro de sessão atual do equipamento
  const getSessionIdAsync = async (
    registroSessaoPOSId?: string
  ): Promise<string | undefined> => {
    if (!registroSessaoPOSId) {
      return undefined;
    }

    const eventSession = await localStorageRepository.get<IEventSession>(
      keyStorage
    );

    return eventSession?.registroSessaoPOSId?.toLowerCase() ===
      registroSessaoPOSId.toLowerCase()
      ? eventSession.sessionId
      : undefined;
  };

  return { saveAsync, getSessionIdAsync };
};
